const START_SESSION_SUCCESS = 'START_SESSION_SUCCESS'
const START_SESSION_FAILURE = 'START_SESSION_FAILURE'
const START_SESSION_STARTED = 'START_SESSION_STARTED'

export { START_SESSION_SUCCESS, START_SESSION_FAILURE, START_SESSION_STARTED }
